import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import cx from 'classnames';
import { ContentSwitcher } from '@xingternal/content-switcher';

import { Meta } from '@xingternal/typography';

import { COMMBOX_SCHEDULING_HOUR_SUGGESTIONS } from '../constants';

import styles from './styles.css';

const TimeSelector = ({ onSelectTime, selectedTime, minimumHourAllowed }) => {
  const [selectedContentOption, setSelectedContentOption] = useState(null);
  const contentSwitcherArray = COMMBOX_SCHEDULING_HOUR_SUGGESTIONS.map(
    (time, idx) => {
      const hour = Number(time.split(':')[0]);
      return {
        className: `${styles.reco} ${
          hour < minimumHourAllowed ? styles.timeDisabled : ''
        }`,
        copy: time,
        'data-testid': `commbox-scheduling-time-option-${idx}`,
        onClick: (e) => {
          if (hour >= minimumHourAllowed) {
            onSelectTime(e.target.innerText);
            setSelectedContentOption(idx);
          }
        },
      };
    }
  );
  const recommendedHours = [
    contentSwitcherArray[3],
    contentSwitcherArray[6],
    contentSwitcherArray[12],
  ];

  useEffect(() => {
    const inputTimeExistsAsButtton = contentSwitcherArray.find(
      (timeButton) => timeButton.copy === selectedTime
    );
    if (inputTimeExistsAsButtton) {
      const buttonIndex = inputTimeExistsAsButtton['data-testid']
        .split('-')
        .slice(-1)[0];
      setSelectedContentOption(Number(buttonIndex));
    } else {
      setSelectedContentOption(null);
    }
  }, [selectedTime]);

  return (
    <div className={styles.timeSelector}>
      <Meta
        className={cx(styles.timeSelectorHeader, styles.timeSelectorHeader)}
        size="small"
      >
        <FormattedMessage id="COMMBOX_SCHEDULING_HOUR_RECOS" />
      </Meta>
      <ContentSwitcher
        className={styles.timeOptions}
        data={recommendedHours}
        size="small"
        variant="filled"
        allowDropdown={false}
      />
      <hr className={styles.hoursDivider} />
      <ContentSwitcher
        activeItemIndex={selectedContentOption}
        className={styles.timeOptions}
        data={contentSwitcherArray}
        size="small"
        allowDropdown={false}
      />
      <div className={styles.heightHack}></div>
    </div>
  );
};

TimeSelector.propTypes = {
  minimumHourAllowed: PropTypes.number.isRequired,
  onSelectTime: PropTypes.func.isRequired,
  selectedTime: PropTypes.string.isRequired,
};

export { TimeSelector };
